import { render, staticRenderFns } from "./bancada-emissao.vue?vue&type=template&id=8d40bb2a"
import script from "./bancada-emissao.vue?vue&type=script&lang=js"
export * from "./bancada-emissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports